export default "/_next/static/images/Contemporary-c770e95c40df98c0da64a14b32293ed4.png";